//DB
import submissionModel from '../../models/submissionModel';
import {
  LOCAL_STORAGE_KEYS,
  SUBMISSION_STATUS,
} from '../../constants/AppConstants';
import _ from 'lodash';
import {
  getUserFirstName,
  getUserLastName,
  PBStorage,
} from '../../services/storageService/GlobalData';

class SubmissionsManager {
  async saveActivitySubmissions(
    submissions,
    activityNumber,
    instanceName,
    isBackdated,
  ) {
    try {
      let submissionList =
        (await PBStorage.get(LOCAL_STORAGE_KEYS.SUBMISSIONS)) || [];
      //check if their are any submissions for this activity with instance
      let activitySubmissions = submissionList.filter(
        (i) => i.activity_number == activityNumber,
      );
      if (instanceName)
        activitySubmissions = activitySubmissions.filter(
          (i) => i.instanceName == instanceName,
        );

      if (submissions.length <= 10 || isBackdated) {
        let arr = [];
        for (let i in submissions) {
          arr.push(
            submissionModel(
              submissions[i],
              null,
              activityNumber,
              instanceName,
              isBackdated,
            ),
          );
        }

        let idsArr = arr.map((q) => q.id);

        if (submissionList) {
          let filtered = submissionList.filter((q) => !idsArr.includes(q.id));
          let submissionArr = [...arr, ...filtered];

          await PBStorage.set(LOCAL_STORAGE_KEYS.SUBMISSIONS, submissionArr);
        } else {
          await PBStorage.set(LOCAL_STORAGE_KEYS.SUBMISSIONS, arr);
        }

        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log('saveActivitiesSubmissionsfailed', e);
      return false;
    }
  }

  async getActivitySubmissions(activityNumber, startIndex, isBackdated) {
    try {
      let submissions =
        (await PBStorage.get(LOCAL_STORAGE_KEYS.SUBMISSIONS)) || [];
      submissions = submissions.filter(
        (q) => q.activity_number == activityNumber,
      );
      if (isBackdated)
        submissions = submissions.filter((q) => q.isBackdated == true);
      let sortedSubmissions = submissions.sort((a, b) =>
        b.submitted_date.localeCompare(a.submitted_date),
      );

      const filteredSubmissions = sortedSubmissions.slice(0, startIndex + 10);
      return sortedSubmissions;
    } catch (e) {
      console.log('getActivitiesSubmissionsfailed', e);
      return false;
    }
  }

  async getInstanceSubmissions(
    activityNumber,
    instanceName,
    startIndex,
    isBackdated,
  ) {
    try {
      let submissions =
        (await PBStorage.get(LOCAL_STORAGE_KEYS.SUBMISSIONS)) || [];
      submissions = submissions.filter(
        (q) =>
          q.activity_number == activityNumber &&
          q.instance_value == instanceName,
      );
      if (isBackdated)
        submissions = submissions.filter((q) => q.isBackdated == true);
      let sortedSubmissions = submissions.sort((a, b) =>
        b.submitted_date.localeCompare(a.submitted_date),
      );

      const filteredSubmissions = sortedSubmissions.slice(0, startIndex + 10);
      return sortedSubmissions;
    } catch (e) {
      console.log('getInstanceSubmissionsfailed', e);
      return false;
    }
  }

  async clearSubmissions() {
    await PBStorage.set(LOCAL_STORAGE_KEYS.SUBMISSIONS, []);
  }

  async clearActivitySubmissions(activityNumber) {
    try {
      let submissions =
        (await PBStorage.get(LOCAL_STORAGE_KEYS.SUBMISSIONS)) || [];
      submissions = submissions.filter(
        (q) =>
          q.activity_number != activityNumber ||
          (q.activity_number == activityNumber && q.status == 3),
      );
      await PBStorage.set(LOCAL_STORAGE_KEYS.SUBMISSIONS, submissions);
    } catch (e) {
      console.log('error clearActivitySubmissions', e);
    }
  }

  async clearInstanceSubmissions(instanceName) {
    try {
      let submissions =
        (await PBStorage.get(LOCAL_STORAGE_KEYS.SUBMISSIONS)) || [];
      submissions = submissions.filter(
        (q) =>
          q.instance_value != instanceName ||
          (q.instance_value == instanceName && q.status == 3),
      );
      await PBStorage.set(LOCAL_STORAGE_KEYS.SUBMISSIONS, submissions);
    } catch (e) {
      console.log('error clearInstanceSubmissions', e);
    }
  }

  async getSubmissionById(id) {
    let submissions =
      (await PBStorage.get(LOCAL_STORAGE_KEYS.SUBMISSIONS)) || [];
    if (submissions) {
      let filtered = submissions.filter((q) => q.id == id);

      if (filtered[0]) {
        return filtered[0];
      }
    }
    return {};
  }

  async getSubmissionByFeedlotActivitySubmissionId(id) {
    let submissions =
      (await PBStorage.get(LOCAL_STORAGE_KEYS.SUBMISSIONS)) || [];

    submissions = submissions.filter(
      (q) => q.feedlot_activity_submission_id == id,
    );

    if (submissions[0]) {
      return submissions[0];
    }
    return {};
  }

  async saveActivitySubmissionByStatus(
    submission,
    activityNumber,
    instanceName,
    status,
    submissionId,
  ) {
    try {
      let id = null;
      if (submission && submission.status === SUBMISSION_STATUS.REMOVED) {
        let submissions =
          (await PBStorage.get(LOCAL_STORAGE_KEYS.SUBMISSIONS)) || [];
        let obj = submissions.filter(
          (q) =>
            q.feedlot_activity_submission_id ==
            `"${submission.feedlot_activity_submission_id}"`,
        );
        let filterList = submissions.filter(
          (q) =>
            q.feedlot_activity_submission_id !=
            `"${submission.feedlot_activity_submission_id}"`,
        );
        if (obj && obj.length > 0) {
          obj = obj[0].id;
          const values = obj.values;
          let removedObj = submissionModel(submission, obj.id);
          removedObj.values = values;
          filterList.push(removedObj);
          await PBStorage.set(LOCAL_STORAGE_KEYS.SUBMISSIONS, filterList);
        }
      } else if (
        submission &&
        submission.status === SUBMISSION_STATUS.SUBMITTED
      ) {
        let submissions =
          (await PBStorage.get(LOCAL_STORAGE_KEYS.SUBMISSIONS)) || [];
        if (status == SUBMISSION_STATUS.PENDING) {
          submission.status = status;
          submission.feedlotActivitySubmissionCancellation =
            submission.feedlot_activity_submission_cancellation;
          delete submission.feedlot_activity_submission_cancellation;
          submission.feedlotActivitySubmissionCancellation[
            'cancellation_date'
          ] = '2020-10-07T07:42:36.965Z';
          submission.feedlotActivitySubmissionCancellation[
            'cancelled_by_user'
          ] = getUserFirstName() + ' ' + getUserLastName();
          submission.removeCallPending = true;

          let oldSubmissionIndex = submissions.findIndex(
            (q) => q.id == submission.id,
          );
          if (oldSubmissionIndex != -1) {
            submissions[oldSubmissionIndex] = submission;
          } else {
            submissions.push(submission);
          }
        } else {
          submissions.push(submissions);
        }
        await PBStorage.set(LOCAL_STORAGE_KEYS.SUBMISSIONS, submissions);
        id = submission.id;
      }

      if (submission && !submission.status && status) {
        submission.status = status;
        const submissionObj = submissionModel(
          submission,
          submissionId,
          activityNumber,
          instanceName,
          new Date(submission.submitted_date) < new Date(),
        );
        let submissions =
          (await PBStorage.get(LOCAL_STORAGE_KEYS.SUBMISSIONS)) || [];

        submissions.push(submissionObj);
        await PBStorage.set(LOCAL_STORAGE_KEYS.SUBMISSIONS, submissions);
        id = submissionObj.id;
      }

      return id;
    } catch (e) {
      console.log('saveActivitiesSubmissionsfailed', e);
      return false;
    }
  }

  async getPendingActivitySubmissions() {
    let submissions =
      (await PBStorage.get(LOCAL_STORAGE_KEYS.SUBMISSIONS)) || [];

    submissions = submissions.filter(
      (q) => q.status == `${SUBMISSION_STATUS.PENDING}`,
    );

    return submissions;
  }

  async removePendingSubmissions() {
    try {
      let submissions =
        (await PBStorage.get(LOCAL_STORAGE_KEYS.SUBMISSIONS)) || [];
      submissions = submissions.filter(
        (q) => q.status != SUBMISSION_STATUS.PENDING,
      );

      if (submissions.length > 0) {
        await PBStorage.set(LOCAL_STORAGE_KEYS.SUBMISSIONS, submissions);
      } else {
        PBStorage.del(LOCAL_STORAGE_KEYS.SUBMISSIONS);
      }
    } catch (e) {
      console.log('error removing submission', e);
    }
  }

  async removeRejectedSubmission(id) {
    let submissions =
      (await PBStorage.get(LOCAL_STORAGE_KEYS.SUBMISSIONS)) || [];
    if (submissions) {
      let filtered = submissions.filter((q) => q.id != id);
      await PBStorage.set(LOCAL_STORAGE_KEYS.SUBMISSIONS, filtered);
    }

    return true;
  }

  async resetSubmissions(activityNumber) {
    let submissions =
      (await PBStorage.get(LOCAL_STORAGE_KEYS.SUBMISSIONS)) || [];

    if (submissions) {
      let otherActivitySubmissions = submissions.filter(
        (q) =>
          q.activity_number != activityNumber ||
          q.status == `${SUBMISSION_STATUS.PENDING}` ||
          q.status == `${SUBMISSION_STATUS.REJECTED}`,
      );
      let thisActivitySubmissions = submissions.filter(
        (q) =>
          q.activity_number == activityNumber &&
          q.status != `${SUBMISSION_STATUS.PENDING}` &&
          q.status != `${SUBMISSION_STATUS.REJECTED}`,
      );
      thisActivitySubmissions = thisActivitySubmissions.reverse();
      thisActivitySubmissions = thisActivitySubmissions.splice(0, 10);
      //replace other activity submissions and this activity's 10 submissions only
      submissions = Array.from(
        new Set([...otherActivitySubmissions, ...thisActivitySubmissions]),
      );
      await PBStorage.set(LOCAL_STORAGE_KEYS.SUBMISSIONS, submissions);
    }

    return submissions || [];
  }
}

export default new SubmissionsManager();
